import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Overline } from "@/components/Reveal";

const MSG = {
  loading: ["Désabonnement en cours…", "Unsubscribing…"],
  done: ["Vous êtes désabonné(e). Vous ne recevrez plus la newsletter HERUS.", "You have been unsubscribed. You will no longer receive the HERUS newsletter."],
  error: ["Ce lien de désabonnement est invalide ou a expiré.", "This unsubscribe link is invalid or has expired."],
};

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    document.title = "Désabonnement | HERUS";
    const token = params.get("token");
    if (!token) return setState("error");
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/subscribers/unsubscribe`, { token })
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div data-testid="unsubscribe-page" className="bg-[#F9F6F0] min-h-[70vh]">
      <section className="pt-44 pb-24 mx-auto max-w-3xl px-6">
        <Overline>Newsletter</Overline>
        <h1 className="mt-8 font-serif-display font-light text-4xl sm:text-5xl text-[#0A0A0A]">Désabonnement</h1>
        <p data-testid="unsubscribe-status" className="mt-8 text-[#0A0A0A]/75 text-lg font-light leading-relaxed">{MSG[state][0]}</p>
        <p className="mt-2 text-[#0A0A0A]/50 font-light italic">{MSG[state][1]}</p>
        <Link to="/observatoire" data-testid="unsubscribe-back-link" className="mt-10 inline-flex text-xs uppercase tracking-[0.2em] text-[#0A0A0A] border-b border-[#C5A059] pb-1 hover:text-[#C5A059] transition-colors">
          Observatoire HERUS
        </Link>
      </section>
    </div>
  );
}
